import { useReveal } from "@/hooks/useReveal";
import { useCart } from "@/context/CartContext";
import { ShoppingBag } from "lucide-react";
import { Link } from "react-router-dom";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_girl-activity-hub/artifacts/ohgdr8g2_Pink%20Black%20Simple%20Minimalist%20Aesthetic%20Ribbon%20Fashion%20Logo_20260702_100640_0000.png";

export default function Navbar() {
  const ref = useReveal();
  const { count, setIsOpen } = useCart();

  return (
    <header
      ref={ref}
      className="reveal sticky top-0 z-40 backdrop-blur bg-[#FFFDF9]/85 border-b border-[#E8D7D0]"
      data-testid="site-navbar"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 py-3 sm:py-4 flex items-center justify-between">
        <Link
          to="/"
          className="flex items-center gap-3"
          data-testid="nav-logo"
        >
          <img
            src={LOGO_URL}
            alt="Me Amor — Confidence Starts Here"
            className="h-12 sm:h-14 w-auto object-contain"
          />
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm text-[#36292A]">
          <a
            href="/#boxes"
            className="hover:text-[#C48B9F] transition-colors"
            data-testid="nav-boxes"
          >
            The Boxes
          </a>
          <a
            href="/#story"
            className="hover:text-[#C48B9F] transition-colors"
            data-testid="nav-story"
          >
            Our Story
          </a>
          <a
            href="/#newsletter"
            className="hover:text-[#C48B9F] transition-colors"
            data-testid="nav-newsletter"
          >
            Pen Pal Club
          </a>
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="/#boxes"
            className="me-btn-primary hidden sm:inline-flex"
            data-testid="nav-cta-shop"
          >
            Shop
          </a>
          <button
            aria-label="Open basket"
            onClick={() => setIsOpen(true)}
            className="relative w-11 h-11 rounded-full border border-[#E8D7D0] bg-white flex items-center justify-center text-[#36292A] hover:border-[#C48B9F] hover:text-[#C48B9F] transition-colors"
            data-testid="nav-cart-button"
          >
            <ShoppingBag size={18} />
            {count > 0 && (
              <span
                className="absolute -top-1 -right-1 min-w-[20px] h-5 px-1 rounded-full bg-[#C48B9F] text-white text-[11px] leading-5 text-center font-medium"
                data-testid="nav-cart-count"
              >
                {count}
              </span>
            )}
          </button>
        </div>
      </div>
    </header>
  );
}
